import {Component, OnInit} from '@angular/core';
import {I18NService} from '../../i18n/i18n.service';
import {MsgBoxService} from '../../shared/msg-box.service';
import {ApiService} from '../../api/api.service';
import {ActivatedRoute} from '@angular/router';
import {OnboardingError} from '../../api/errors';

const RESEND_DELAY = 5000;

@Component({
    selector: 'app-onboarding-invalid',
    templateUrl: './onboarding-invalid.component.html',
    styleUrls: ['./onboarding-invalid.component.scss']
})
export class OnboardingInvalidComponent implements OnInit {

    totp: string;
    error: OnboardingError;
    reqSent: boolean;

    // exported in HTML
    OnboardingError = OnboardingError;

    constructor(private readonly i18n: I18NService,
                private readonly apiService: ApiService,
                private readonly route: ActivatedRoute,
                private readonly msgBoxService: MsgBoxService) {
        this.reqSent = false;
    }

    ngOnInit() {
        this.totp = this.route.snapshot.queryParamMap.get('totp');
        this.error = this.route.snapshot.queryParamMap.get('error') as OnboardingError || OnboardingError.GENERIC;
    }

    onSubmit() {
        this.reqSent = true;
        this.apiService.inviteMember(this.totp)
            .then(() => {
                this.msgBoxService.info(this.i18n.translate('Request sent, thank you!'));
                this.rescheduleReqSent();
            })
            .catch(err => {
                this.msgBoxService.error(this.i18n.translate('An error occurred while sending invitation request.'), err);
                this.rescheduleReqSent();
            });
    }

    private rescheduleReqSent() {
        setTimeout(() => this.reqSent = false, RESEND_DELAY);
    }
}
